'use client'
import { Trans } from '@lingui/react/macro'
import { usePathname } from '@/lib/next-shim'

import { useBooking } from '../model/bookingContext'

type HeaderProps = {
  meetingLink: string
}

export default function Header(props: HeaderProps) {
  const { meetingLink } = props

  const pathname = usePathname()
  const { goToPreviousStep } = useBooking()

  const handleNavigateBack = () => {
    if (!pathname) return
    goToPreviousStep()
  }

  return (
    <div className="relative flex flex-1 items-center justify-center px-4 py-7">
      {!pathname?.endsWith('/speciality') && (
        <button className="absolute left-2 rounded-full p-2 text-white transition-colors hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/60" onClick={handleNavigateBack} type="button">
          <span className="sr-only">
            <Trans>Go back</Trans>
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6" aria-hidden="true">
            <path
              fillRule="evenodd"
              d="M15.78 4.72a.75.75 0 010 1.06L9.56 12l6.22 6.22a.75.75 0 11-1.06 1.06l-6.75-6.75a.75.75 0 010-1.06l6.75-6.75a.75.75 0 011.06 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
      <h1 className="text-xl font-bold text-white">
        {/* {meetingLink.name} */}
        {meetingLink}
      </h1>
    </div>
  )
}
